export default __webpack_public_path__ + "57685a975e6610b5cfc5cd4495d6b3a3.svg";